<template>
  <div class="updateSchedule">
    <VDialog v-model="modelVisible" size="large-plus">
      <div>
        <div class="pop-up__close" @click="$emit('close')">
          <img src="@/assets/img/svg/close.svg" alt="close" />
        </div>

        <ErrorBanner
          :errors="[translations.updateSchedulesIntro.text]"
          class="add-prices-pop-up__info-banner"
        />

        <div
          v-for="(option, optionIndex) in options"
          :key="`option-${optionIndex}`"
          class="updateSchedule__title"
        >
          <div v-if="optionIndex == currentPageIndex">
            <h1 class="updateSchedule__title">{{ getScheduleTitle() }}:</h1>
            <h3 class="updateSchedule__title2">"{{ option.name }}"</h3>

            <div
              v-for="(schedule, scheduleIndex) in option.schedules"
              :key="`schedule-${scheduleIndex}`"
              class="index-price-page__price"
            >
              <div
                v-for="(priceSchedule, priceScheduleIndex) in schedule.price_schedules"
                :key="`priceSchedule-${priceScheduleIndex}`"
                @mouseleave="showEditMenu = null"
              >
                <EditPrices
                  v-if="newScheduleType != null"
                  :ref="
                    getRef(
                      newScheduleType,
                      optionIndex,
                      scheduleIndex,
                      priceScheduleIndex
                    )
                  "
                  :is-active="true"
                  :tour="tour"
                  :tour-lang="lang"
                  :tour-members="schedule.price_schedules[priceScheduleIndex].members"
                  :ticket-index="scheduleIndex"
                  :price-schedule="schedule.price_schedules[priceScheduleIndex]"
                  :schedule-type="newScheduleType"
                  :translations="pricesTranslate"
                  :schedule="schedule"
                  editType="times"
                  embedType="schedule-update"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="updateSchedule__buttons">
          <v-btn
            v-if="currentPageIndex === 0"
            outline
            :name="translations.cancelBtn.text"
            @click="$emit('close')"
          />
          <v-btn
            v-else
            outline
            :name="translations.backBtn.text"
            @click="currentPageIndex--"
          />

          <v-btn
            v-if="currentPageIndex === options.length - 1"
            base
            :name="translations.saveBtn.text"
            :enabled="true"
            @click="save()"
          />
          <v-btn
            v-else
            base
            :name="translations.nextBtn.text"
            :enabled="true"
            @click="currentPageIndex++"
          />
        </div>

        <div class="row">
          <div class="nav__pagination">
            <div v-for="(option, optionIndex) in options" :key="`pageNum${optionIndex}`">
              <div
                class="dot dot_page"
                :class="{ dot_page_active: optionIndex == currentPageIndex }"
              />
            </div>
          </div>
        </div>
      </div>
    </VDialog>
    <hr />
  </div>
</template>

<script>
import VDialog from "@/components/common/VDialog.vue";
import EditPrices from "@/components/pop-up/price/EditPrices.vue";
import VBtn from "@/components/controls/VBtn.vue";
export default {
  components: {
    VDialog,
    EditPrices,
    VBtn,
  },
  props: {
    isActive: { type: Boolean, default: false },
    tour: { type: Object, default: () => ({}) },
    newScheduleId: { type: Number, default: null },
    options: { type: Array, default: () => [] },
    translations: { type: Object, default: () => ({}) },
    pricesTranslate: { type: Object, default: () => ({}) },
    priceOption: { type: Object, default: () => ({}) },
  },
  data: () => ({
    lang: "",
    scheduleTypes: [],
    newScheduleType: null,
    childComponents: new Set(),
    currentPageIndex: 0,
  }),

  async beforeCreate() {
    this.lang = this.$cookies.get("i18n_redirected");
    this.scheduleTypes = await this.$axios.$get(
      `/api/v1/show-schedule-types/?language=${this.tourLang}`
    );
    this.newScheduleType = this.scheduleTypes.filter(
      (x) => x.id == this.newScheduleId
    )[0];
    let v = this.newScheduleType;
  },

  methods: {
    getRef(newScheduleType, optionIndex, scheduleIndex, priceScheduleIndex) {
      if (newScheduleType != null) {
        let ref = "c" + optionIndex + "_" + scheduleIndex + "_" + priceScheduleIndex;
        this.childComponents.add(ref);
        return ref;
      }
    },

    getScheduleTitle() {
      if (this.newScheduleId == 1) {
        return this.translations.updateStartTimes.text;
      } else if (this.newScheduleId == 2) {
        return this.translations.updateOpeningHours.text;
      } else if (this.newScheduleId == 5) {
        return this.translations.updateCoordinatedStartTimes.text;
      }
      return "";
    },

    getSchedule(schedule) {
      console.log("returning " + this.scheduleTypes);
      return schedule.schedule_type;
    },

    close() {
      this.modelVisible = false;
    },

    back() {
      this.modelVisible = false;
    },

    async validate(index) {
      let r = this.$refs;
      let child = this.childComponents[index];
      child.validate();
    },

    async save() {
      let r = this.$refs;
      let children = this.childComponents;

      children.forEach(async function (child) {
        console.log("save: " + child);
        if (r[child].length > 0) {
          await r[child][0].save();
        }
      });

      this.modelVisible = false;
      this.$emit("save");
    },
  },

  computed: {
    modelVisible: {
      get() {
        return this.isActive;
      },
      set(visible) {
        this.$emit("update:isActive", visible);
      },
    },
  },
};
</script>

<style lang="scss">
.updateSchedule {
  &__title {
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    font-weight: bold;
    font-size: 32px;
    line-height: 48px;
  }

  &__title2 {
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    font-weight: bold;
    font-size: 24px;
    line-height: 36px;
  }
  &__buttons {
    border-top: 1px solid #ececec;
    padding-top: 24px;
    display: flex;
    justify-content: right;
  }
}
div.index-price-page__price {
  border: none;
  box-shadow: none;
  width: 100%;
  margin-top: 0px;
}

.nav__pagination {
  margin-top: 30px;
  display: flex;
  margin-left: auto;
  margin-right: auto;
}

.error-banner {
  margin: 16px 0 0;
}

.v-btn_outline {
  margin-right: 16px;
}

button.v-btn {
  min-width: 100px !important;
}

.pop-up__close {
  right: 32px;
}
</style>
